/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import styles from "./timeline.module.scss";

function Timeline({ steps }) {
  return (
    <ul className={styles.timeline}>
      {steps.map((step, index) => (
        <li map={index} className={styles.timeline__step} key={step}>
          <div dangerouslySetInnerHTML={{ __html: step }} className={styles["timeline__step-content"]} />
        </li>
      ))}
    </ul>
  );
}

Timeline.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Timeline;
